module.exports = __webpack_public_path__ + "assets/img/warrior-name-7991be8b.png";